import React, {useRef, useState} from 'react';
import {
  Button, Card, Col, Form, Row,
} from 'react-bootstrap';
import {dateRenderer, floatMarkRender, floatRenderer} from '../../services/formatSvc';
import {FloatInput, FloatMarkInput} from "../common/MonetaryFloatInput";
import ExpertReportContent from "./ExpertReportContent";
import {submitContainer, submitForm} from "../../utils/validation";
import useToast from "../../hooks/useToast";

export default function ExpertCard({
  className, decision, onDecisionChange, onSubmit, onEdit, readOnly, canEdit,status
}) {

  const [validated,setValidated] = useState(false)
  const formEl = useRef(null)
  const addToast = useToast()

  const handleIsApprovedChange = (value) => {
    onDecisionChange('isApproved', value);
  };

  const handleRecommendationsChange = ({ target }) => {
    onDecisionChange('recommendations', target.value);
  };

  const handleProtocolChange = ({ target }) => {
    onDecisionChange('protocol', target.value);
  };

  const handleDecisionDateChange = ({ target }) => {
    onDecisionChange('decisionDate', target.value);
  };

  const handleChangeFiles = (newFiles) => {
    onDecisionChange('decisionFiles',newFiles)
  }

  const handleMarkChange = ( target ) => {
    (target>=0 && target <=10) || !target ?  onDecisionChange('mark',target ?? '') : onDecisionChange('mark',decision.mark)
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await onSubmit();
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await onEdit();
  };

  const handleSubmitContainer = (event,callback) => {
    submitContainer(event,formEl)
        .then(()=>callback(event))
        .catch((err)=>addToast.error(err))
  }

  return (
    <Card className={className}>
      {/*<Form noValidate validated={validated} ref={formEl} onSubmit={handleSubmitForm}>*/}
      <Card.Header as={Card.Title} className="p-4">
        Решение экспертной группы
      </Card.Header>
      <Card.Body className="p-4">
        <div ref={formEl}>
            <ExpertReportContent status={status} readOnly={readOnly} canEdit={canEdit} decision={decision} callbacks={{handleIsApprovedChange,handleDecisionDateChange,handleRecommendationsChange,handleProtocolChange,handleMarkChange,handleChangeFiles}}/>
        </div>
            {!readOnly && canEdit && <Button as={Col}  variant="outline-primary" onClick={(event)=>handleSubmitContainer(event,handleSubmit)} >Сохранить решение</Button>}
            {readOnly && canEdit && <Button as={Col} type={'submit'} variant="outline-primary" onClick={(event)=>handleSubmitContainer(event,handleEdit)}>Сохранить рекомендации/реквизиты протокола</Button>}
      </Card.Body>
      {/*</Form>*/}
    </Card>
  );
}
